import React from "react";
import "./styles/PoliticaCancelamento.css";

import { IoMdArrowRoundBack } from "react-icons/io";

import { useNavigate } from "react-router-dom";

export default function PoliticaCancelamento() {
  const navigate = useNavigate();

  return (
    <div className="politica-container">
      <button className="voltar-home-button" onClick={() => navigate("/")}>
        <IoMdArrowRoundBack /> <p>
          Voltar para o início
        </p>
      </button>
      <h2>Política de Cancelamento - Arena Central</h2>

      <p>
        Na Arena Central, prezamos pelo compromisso e organização para oferecer
        a melhor experiência possível para nossos clientes.
      </p>

      <h3>Cancelamento de Reservas</h3>
      <ul>
        <li>
          O cancelamento deve ser solicitado com, no mínimo,{" "}
          <strong>4 horas</strong> de antecedência em relação ao horário
          reservado.
        </li>
        <li>
          Solicitações feitas fora deste prazo não terão direito a reembolso ou
          reposição de horário.
        </li>
      </ul>

      <h3>Como Cancelar</h3>
      <p>
        Envie uma mensagem pelo nosso WhatsApp (
        <a
          href="https://wa.me/5532999649956"
          target="_blank"
          rel="noopener noreferrer"
        >
          clique aqui
        </a>
        ) informando:
      </p>
      <ul>
        <li>Nome do responsável pela reserva</li>
        <li>Data e horário agendado</li>
        <li>Motivo do cancelamento (opcional)</li>
      </ul>

      <h3>Reembolsos</h3>
      <p>
        Reservas pagas antecipadamente e canceladas dentro do prazo terão
        direito a reembolso integral ou crédito para um próximo agendamento,
        conforme preferência do cliente.
      </p>

      <h3>Casos Especiais</h3>
      <p>
        Cancelamentos devido a condições climáticas extremas ou imprevistos
        operacionais da Arena Central não gerarão custos para o cliente.
      </p>

      <p>
        Em caso de dúvidas, entre em contato conosco diretamente pelo WhatsApp.
      </p>

      <hr />
      <p>
        <em>Arena Central - CNPJ: 59.567.211/0001-53</em>
      </p>
    </div>
  );
}



// colocar 7 dias pra frente